export default "__VITE_ASSET__C36Wsj5T__"